import React from 'react'
import PropTypes from 'prop-types'
import { withAppContext } from '../utils/AppContext'

import Icon from './Icon'

import styles from '../scss/layout/app.scss'

const SocialShareButton = ({ onClick, iconSize, color, className }) => (
    <button onClick={() => onClick()} type="button" className={className}>
        <Icon icon="social-share" size={iconSize} color={color} className={styles.icons} />
    </button>
)

SocialShareButton.propTypes = {
    iconSize: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
}

SocialShareButton.defaultProps = {
    className: '',
}

export default withAppContext(SocialShareButton)



// WEBPACK FOOTER //
// ./src/ui/SocialShareButton.js